import { DbApi } from "common-library/types"

export const getFootfallFeature = function (f: { [key in DbApi.CameraNS.Feature]?: boolean }) {
  if (!f.counter) return ""
  if (f.trackcounter) return "tFF"
  if (f.metacounter) return "mFF"
  if (f.facecounter) return "fFF"
  return "FF"
}

export const getSourceTypeFromFeature = function (f: string) {
  if (f == "tFF") return "CA"
  if (f == "fFF") return "FC"
  // else "FF" or "mFF"
  return "VCA"
}
